import { FormsModule } from '@angular/forms';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';
import { Component, OnInit, ChangeDetectorRef, Input } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TGLinksInfo, TgSettingsService } from 'app/services/TG-Setting_Services/tg-settings.service';
import { TranslateModule } from "@ngx-translate/core";

import { TranslationInitService } from 'app/services/Translate_Services/translation-init.service';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'page-footer',
  imports: [CommonModule, FormsModule, TranslateModule],
  standalone: true,
  templateUrl: './page-footer.component.html',
  styleUrls: ['./page-footer.component.scss']
})
export class PageFooterComponent implements OnInit {
    constructor(private translate: TranslateService, private cdr: ChangeDetectorRef, private tgSettingsService: TgSettingsService, private translationInit: TranslationInitService, private sanitizer: DomSanitizer) { console.log(this.TgSettings); }
  showDialog: boolean = false;
  showLeaveDialog: Boolean = false;
  pendingUrl = '';
  bSaveDraft: boolean = false;
  daysInDraft?: number;
  footerLinks: TGLinksInfo[] = [];
  footerIndex: number = 0;
  footerAlert: string = '';
  formattedFooter: TGLinksInfo[][] = [];
  clientFooter: TGLinksInfo | null = null;
  clientFooterHtml: SafeHtml | null = null;
  showMaincontent: boolean = false;
  talentSuiteJS = false;
  response: any = { LocaleDesc: 'English', TGLocales: [] };
  translateStrings: any = {};
  partnerId: string = "";
  siteId: string = "";
  EncryptedSessionId: string = "";
  PageFooter: string = '';
  selectedMenuItem: string = '';
  AcceptedCookieConsent: string = '';
  Necessary_Cookies: any[] = [];
  Policy_Cookies: string = '';
  Stastistical_Cookies: any[] = [];
  unsavedChanges: boolean = false;
  showModal = false;
  showEditForm = false;
  showFileNameModal = false;
  newSectionType = "";
  cookieMoreInformationVisible: boolean = false;
  cookieCategories: any[] = [];
  statisticCookiesCount: number = 0;
  unclassifiedCookiesCount: number = 0;
  getCustomCategoryCookiesCount!: (categoryName: string) => number;
  bConfigMode: boolean = false;
  fromts: boolean = false;
  showCookieConsent: boolean = true;
  showConfirmationModal: boolean = false;
  localesDialogVisible: boolean = false;
  leaveDialogVisible: boolean = false;
  switchSiteDialogVisible: boolean = false;
  jobsDraftDialogVisible: boolean = false;
  confirmValue: boolean = false;
  targetUrl: string = '';
  footerInfo: TGLinksInfo[] = [];
  selectedCategory: any;
  TgSettings: any = {};
  translatedFooterText?: string;
  private sub!: Subscription;
  showLocalesDialogBox: boolean = false;
  footerfromparent: TGLinksInfo[] = [];
  disableClick: boolean = false;

  @Input() set footerInfofromParent(value: any) {
    
    if(value != undefined && value != null && value.clientsettings != undefined && value.clientsettings != null && value.footerinfo != undefined && value.footerinfo != null){
      this.TgSettings = value.clientsettings;
      this.setFooterInfo(value);
    }
  }


  async ngOnInit(): Promise<void> {
    try {
      const translatedFooterText = await this.translationInit.getTranslation('Footer_PrivacyPolicyLink');
      const privacyPolicyText = await this.translationInit.getTranslation('CookieConsent_PrivacySettings');
      this.tgSettingsService.settings$.subscribe(async response => {
        this.TgSettings = response?.tgSettings || {};
        this.footerInfo = response?.footerInfo || [];
        if(translatedFooterText != "Footer_PrivacyPolicyLink"){
          this.footerInfo.push({          
          Name: translatedFooterText,
          Value: this.TgSettings.PrivacyPolicyDocUrl || ''
        })} 
        if(privacyPolicyText != "CookieConsent_PrivacySettings"){
          this.footerInfo.push({
            Name: privacyPolicyText,
            Value: this.TgSettings.CookieConsent_PrivacySettings || ''
          })};
        this.clientFooter = this.footerInfo.find((link: TGLinksInfo) => link.ContentType === 'html') || null;
        if (this.clientFooter?.Value != null) {
          this.clientFooterHtml = this.sanitizer.bypassSecurityTrustHtml(this.clientFooter.Value);
        }
        this.footerLinks = this.footerInfo.filter((link: TGLinksInfo) => link.ContentType !== 'html');
        this.formattedFooter = this.chunkArray(this.footerLinks, 3);
        this.cdr.markForCheck();
      });
    
      this.tgSettingsService.settings$.subscribe(res => {
        if (!res) return;
        this.footerLinks = res.footerInfo;
        this.response = {
          ...this.response,
          TGLocales: res.TGLocales
        };
      });
    } catch (error) {
      console.error(error);
    }
  }

  private chunkArray(array: TGLinksInfo[], size: number): TGLinksInfo[][] {
    const chunks: TGLinksInfo[][] = [];
    for (let i = 0; i < array.length; i += size) {
      chunks.push(array.slice(i, i + size));
    }
    return chunks;
  }

  footerNextPrevEnable(action: 'prev' | 'next'): boolean {
    if (!this.footerLinks?.length) {
      return false;
    }
    const itemsPerPage = 3;
    const totalPages = Math.ceil(this.footerLinks.length / itemsPerPage);
    return action === 'prev'
      ? this.footerIndex > 0
      : this.footerIndex < totalPages - 1;
  }





  footerSlide(direction: 'prev' | 'next', step: number): void {
    const segments = document.querySelectorAll('.footerLinkContSegment');
    segments.forEach(el => {
      el.classList.remove('nga-squash-left-add', 'nga-squash-right-add');
      el.classList.add(
        direction === 'next'
          ? 'nga-squash-right-add'
          : 'nga-squash-left-add'
      );
    });

    let index = this.footerIndex;
    const totalPages = Math.ceil(this.footerLinks.length / step);
    if (direction === 'prev' && index > 0) {
      index--;
      this.footerAlert = this.translateStrings.Lbl_PrevFooterLinkLoaded;
    }
    if (direction === 'next' && index < totalPages - 1) {
      index++;
      this.footerAlert = this.translateStrings.Lbl_NextFooterLinkLoaded;
    }
    setTimeout(() => {
      this.footerIndex = index;
      this.footerAlert = '';
      this.scrollbottom();
      const segmentToFocus = document.querySelector('.footerLinkContSegment');
      (segmentToFocus as HTMLElement)?.focus();
    }, 600);
  }


  scrollbottom(): void {
  }

  showLocalesDialog(): void {
    document.body.classList.add('noScroll');

    setTimeout(() => {
      this.showLocalesDialogBox = true;
    }, 100);
  }

  switchSite(switchToSiteId: string, calledFrom?: string): void {
    const switchSiteRequest = {
      PartnerId: this.partnerId,
      SwitchToSiteId: switchToSiteId,
      FromSiteId: this.siteId,
      CookieValue: (document.getElementById('CookieValue') as HTMLInputElement)?.value || ''
    };
  }

  closeDialogs() {
    // this.service.close('0');
  }

  closeThisDialog(value: '0' | '1') {
    // this.service.close(value);
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }

  confirmSwitch(value: boolean): void {
    // Placeholder - handle switch site confirmation
  }

  confirm(value: boolean | number) {
    const confirmed = !!value;
    this.closeDialogs();
    if (confirmed) {
    } else {
    }
  }

  async setFooterInfo(data: any) {
    this.footerInfo = data.footerinfo;
    this.TgSettings = data.clientsettings;
    const translatedFooterText = await this.translationInit.getTranslation('Footer_PrivacyPolicyLink');
    const privacyPolicyText = await this.translationInit.getTranslation('CookieConsent_PrivacySettings');
    this.clientFooter = this.footerInfo.find((link: TGLinksInfo) => link.ContentType === 'html') || null;
    if (this.clientFooter?.Value != null) {
      this.clientFooterHtml = this.sanitizer.bypassSecurityTrustHtml(this.clientFooter.Value);
    }
    this.footerLinks = this.footerInfo.filter((link: TGLinksInfo) => link.ContentType !== 'html');
    this.formattedFooter = this.chunkArray(this.footerLinks, 3);
    if (!this.footerInfo.some(item => item.Name === translatedFooterText)) {
      this.footerInfo.push({
        Name: translatedFooterText,
        Value: this.TgSettings.PrivacyPolicyDocUrl || ''
      });
    }

    if (!this.footerInfo.some(item => item.Name === privacyPolicyText)) {
      this.footerInfo.push({
        Name: privacyPolicyText,
        Value: this.TgSettings.CookieConsent_PrivacySettings || ''
      });
    }
    this.cdr.markForCheck();
    this.disableClick = true;
  }
}
